import React from 'react';
import SEO from '../components/SEO';

const ThankYou = () => {
  return (
    <div style={{ textAlign: 'center', padding: '4rem' }}>
      <SEO title="Thank You | Bularis Tech" description="Your message has been sent to Bularis Tech." path="/thank-you" noIndex />
      <h1>Thank You!</h1>
      <p>Your message has been sent successfully. We'll get back to you shortly.</p>
    </div>
  );
};

export default ThankYou;
